import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Костыль для структурирования блоков при разработке
 * @param blockName
 * @param isLarge
 * @param isSmall
 * @returns {function({children?: *, className?: *, style?: *})}
 */
export var defineMockBlock = function defineMockBlock(blockName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    isLarge = _ref.isLarge,
    isSmall = _ref.isSmall;
  var MockBlock = function MockBlock(_ref2) {
    var children = _ref2.children,
      className = _ref2.className,
      style = _ref2.style;
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: _objectSpread({
        border: '1px solid #999',
        background: 'rgba(0, 0, 0, 0.1)',
        padding: isLarge && '60px' || isSmall && '20px 5px 5px' || '20px',
        borderRadius: '4px',
        position: 'relative',
        minWidth: '150px'
      }, style),
      "data-t-id": "ui-enhancers"
    }, blockName && /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: '0 2px',
        lineHeight: '14px',
        color: '#fff',
        borderRadius: '4px 0 0 0',
        background: 'rgba(0, 0, 0, 0.5)'
      }
    }, blockName), children);
  };
  MockBlock.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.node,
    style: PropTypes.shape({}),
    className: PropTypes.string
  } : {};
  MockBlock.displayName = "withMock".concat(blockName);
  return MockBlock;
};